<script setup>
import { useMessages } from '../../../composables/useMessages'
import Message from './Message.vue'

const { messages } = useMessages()
</script>

<template>
	<div class="min-h-[150px] fixed right-8 top-14 z-[101]">
		<TransitionGroup
			name="alerts"
			tag="div"
			class="flex flex-col gap-3 items-end"
		>
			<Message
				v-for="message in messages"
				:key="message.id"
				:title="message.title"
				:description="message.description"
				:actions="message.actions"
				:closeable="message.closeable"
				:type="message.type"
			/>
		</TransitionGroup>
	</div>
</template>

<style scoped>
.alerts-enter-active,
.alerts-leave-active {
	transition: all 0.5s ease;
}

.alerts-enter-from,
.alerts-leave-to {
	opacity: 0;
	transform: translateX(30px);
}
</style>
